import { useEffect, useState } from "react";
import { finanzasApi } from "./api.js";

/** Evento que la página de solicitudes dispara al resolver una, para refrescar el contador del menú. */
export const REQUESTS_CHANGED_EVENT = "redipos:requests-changed";

const POLL_MS = 60_000;

/** Cantidad de solicitudes de clientes pendientes (badge del menú). `enabled=false` no consulta nada. */
export function useRequestsBadge(enabled: boolean): number {
  const [pending, setPending] = useState(0);
  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    const refresh = () => {
      finanzasApi
        .requestsCount()
        .then((r) => alive && setPending(r.pending))
        .catch(() => {});
    };
    refresh();
    const timer = window.setInterval(refresh, POLL_MS);
    window.addEventListener(REQUESTS_CHANGED_EVENT, refresh);
    return () => {
      alive = false;
      window.clearInterval(timer);
      window.removeEventListener(REQUESTS_CHANGED_EVENT, refresh);
    };
  }, [enabled]);
  return pending;
}
